import CloseIcon from "@mui/icons-material/Close";
import AlertSubscriptionForm from "../../molecules/AlertSubscriptionForm/AlertSubscriptionForm";
import "./AlertModal.css";
 
const AlertModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
 
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(event) => event.stopPropagation()}>
        <button className="modal-close" onClick={onClose} type="button" aria-label="Fermer">
          <CloseIcon fontSize="small" />
        </button>
 
        <h3 className="modal-title">Recevez l'alerte par e-mail</h3>
        <p className="modal-subtitle">
          Réservée exclusivement aux adresses professionnelles — aucune
          donnée personnelle conservée hormis l'e-mail. Désinscription à
          tout moment via info@ensemblepourlaforet.fr.
        </p>
 
        <AlertSubscriptionForm buttonLabel="Inscrire mon adresse professionnelle aux alertes par e-mail" />
      </div>
    </div>
  );
};
 
export default AlertModal;